import Img1 from './images/phone7.jpg'
import Img2 from './images/phone8.jpg'
import Img3 from './images/phone9.jpg'
import Pop1 from './images/pop1.jpg'
import Pop2 from './images/pop2.jpg'
import Pop3 from './images/pop3.jpg'
import Pop5 from './images/pop5.jpg'
import Pop6 from './images/pop6.webp'
import Pop7 from './images/pop7.jpg'
import Pop8 from './images/pop8.jpg'
import Pop9 from './images/pop9.jpg'

export const popularProducts = [
    {id: 1, img: Pop1},
    {id: 2, img: Pop2},
    {id: 3, img: Pop3},
    {id: 4, img: Pop5},
    {id: 5, img: Pop6},
    {id: 6, img: Pop7},
    {id: 7, img: Pop8},
    {id: 8, img: Pop9}
]


export const categories = [
    {id: 1, img: Pop3, title: 'Men Cools', cat: 'shoes'},
    {id: 2, img: Pop6, title: 'Facial Merits', cat: 'wears'},
    {id: 3, img: Pop5, title: 'Holy Spear', cat: 'caps'}
]

export const sliderItems = [
    {
        id: 1,
        img: Img1,
        title: "WEEKEND SUPER PROM0",
        desc: "DON'T MISS OUT ON THIS. WE HAVE YOU ALL COVERED",
        bg: "f5fafd"
    },
    {
        id: 2,
        img: Img2,
        title: "TRENDS SUPER PROM0",
        desc: "DON'T MISS OUT ON THIS. WE HAVE YOU ALL TRENDY",
        bg: "fcf1ed"
    },
    {
        id: 3,
        img: Img3,
        title: "POPULAR SUPER PROM0",
        desc: "DON'T MISS OUT ON THIS. THIS IS JUST FOR YOU",
        bg: "fbf0f4"
    },
    {
        id: 4,
        img: Pop3,
        title: "POPULAR SUPER PROM0",
        desc: "DON'T MISS OUT ON THIS. THIS IS JUST FOR YOU",
        bg: "fbf0f4"
    },
    {
        id: 5,
        img: Pop8,
        title: "POPULAR SUPER PROM0",
        desc: "DON'T MISS OUT ON THIS. THIS IS JUST FOR YOU",
        bg: "fbf0f4"
    }
]
